import { IConditionalNode } from '../../../../helpers/conditional-nodes.helpers';
import { required } from '../../../../helpers/function.helpers';
import {
  HeatingType,
  HeatingPropertyName,
  energyProductsIdToNameMap,
} from '../heating.model';
import { EnergyProductId } from '../../energy/energy.model';

/**
 * Tree to select energy product depending on heating type
 */
export const conditionalEnergyProductId: IConditionalNode<EnergyProductId> = {
  property: HeatingPropertyName.Type,
  map: {
    // Heating product for heat pumps depending on heat source
    [HeatingType.HeatPump]: EnergyProductId.Electricity,

    // Heating product for boiles depending on fuel type
    [HeatingType.Boiler]: {
      property: HeatingPropertyName.FuelType,
      map: {
        [required(energyProductsIdToNameMap[EnergyProductId.FuelOil1])]:
          EnergyProductId.FuelOil1,
        [required(energyProductsIdToNameMap[EnergyProductId.FuelOil2])]:
          EnergyProductId.FuelOil2,
        [required(energyProductsIdToNameMap[EnergyProductId.WoodPellets])]:
          EnergyProductId.WoodPellets,
        [required(energyProductsIdToNameMap[EnergyProductId.Biogas])]:
          EnergyProductId.Biogas,
      },
    },
    [HeatingType.DistrictHeating]: EnergyProductId.DistrictHeating,
    [HeatingType.DirectElectricHeating]: EnergyProductId.Electricity,
  },
};
